import { randomUUID } from "crypto";
import admin from "firebase-admin";
import { s as stripe } from "./stripe.js";
import { c as sendLicenseEmail } from "./mailer.js";
const generateLicenseAndNotifyUser = async (paymentIntent, infoText) => {
  const license = randomUUID().toUpperCase();
  const customer = await stripe.customers.retrieve(paymentIntent.customer);
  if (customer.deleted || !customer.email) return null;
  await admin.firestore().collection("licenses").doc(customer.email).set({
    code: license
  });
  await sendLicenseEmail(customer.email, license, infoText);
};
export {
  generateLicenseAndNotifyUser as g
};
